import 'core-js/modules/es.object.assign.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import '@mui/material';
import { useUtility } from '../../hooks/use-utility.js';

const CircularProgress = ({
  value,
  size
}) => {
  const {
    palette
  } = useUtility();
  const radius = 40;
  const circumference = 2 * Math.PI * radius;
  const progress = value > 100 ? 100 : value < 0 ? 0 : value;
  const strokeDashoffset = circumference * (1 - progress / 100);
  return jsx("div", Object.assign({
    style: {
      width: size,
      height: size,
      position: 'relative'
    }
  }, {
    children: jsxs("svg", Object.assign({
      height: "100%",
      width: "100%",
      viewBox: "0 0 100 100",
      xmlns: "http://www.w3.org/2000/svg",
      style: {
        transform: `rotate(-90deg)`
      }
    }, {
      children: [jsx("circle", {
        className: "progress-circle-background",
        cx: "50",
        cy: "50",
        r: radius,
        strokeWidth: "14",
        stroke: "#646562",
        fill: "transparent"
      }), jsx("circle", {
        className: "progress-circle",
        cx: "50",
        cy: "50",
        r: radius,
        strokeWidth: "14",
        stroke: palette('onSurface'),
        fill: "transparent",
        strokeDasharray: circumference,
        strokeDashoffset: strokeDashoffset,
        strokeLinecap: "round"
      })]
    }))
  }));
};

export { CircularProgress };
